import { Stack, Typography } from '@mui/joy';
import { ReactNode } from 'react';

import { Image } from 'core/elements';
import { Direction, Level } from 'theme/enums';

interface IProps {
  image: string;
  message: string;
  action: ReactNode;
}

export const PartFinderEmptyState = ({ image, message, action }: IProps) => (
  <Stack direction={Direction.COLUMN} gap={2} alignItems="center">
    <Image src={image} alt="" style={{ width: 'auto', height: 'auto' }} />
    <Typography level={Level.TITLE_MD} textAlign="center">
      {message}
    </Typography>
    {action}
  </Stack>
);
